export class Plan_subscription {

    public relations = ['user', 'payment', 'plan'];

    public names = {
        // therapist_id: function (data) {
        //     // return data.address && data.address.offname;
        // },
        user_id: function(data){
            return data.user?.f + ' ' + data.user?.i + ' ' + data.user?.o;
        },
        payment_id: function(data){
            return data.payment ? ((data.payment.paid ? 'оплачен' : 'не оплачен') + ' - ' + data.payment.price ? data.payment.price : 'бесплатно') : 'не оплачен';
        },
        plan_id: function(data){
            return data.plan ? (data.plan.name + '/' + data.plan.period + ' месяцев по цене ' + data.plan.price) : 'план не существует';
        }
    }
}
